// extracted by mini-css-extract-plugin
export default {"root":"ForgotPasswordPage_root__UulLu","header":"ForgotPasswordPage_header__L3cEp","form-container":"ForgotPasswordPage_form-container__Xsrjj"};